import { Component, OnInit } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { BandaInformacionService } from '../../../services/banda-informacion/banda-informacion.service';

@Component({
  selector: 'app-banda-informacion',
  templateUrl: './banda-informacion.component.html'
})
export class BandInformacionComponent implements OnInit {
  readonly MAX_CHARS = 120;
  loaders = {
    form: false
  };

  bandaInfo = {
    id: null,
    visible: false,
    description: ''
  };

  private isNewRecord = true;

  constructor(
    private toasts: ToastsManager,
    private bandaInformacionService: BandaInformacionService
  ) { }

  ngOnInit() {
    this.loadBandaInfo();
  }

  loadBandaInfo() {
    this.bandaInformacionService.getBandaInfo()
      .subscribe((response: any) => {
        if (response.data && Array.isArray(response.data) && response.data.length > 0) {
          const bandaData = response.data[0];
          this.bandaInfo = {
            id: bandaData.id,
            visible: bandaData.visible || false,
            description: bandaData.description || ''
          };
          this.isNewRecord = false;
        } else {
          this.bandaInfo = {
            id: null,
            visible: false,
            description: ''
          };
          this.isNewRecord = true;
        }
      }, error => {
        console.error('Error loading banda info:', error); // Debug line
        this.toasts.error('Error al cargar la información de la banda');
      });
  }

  toggleVisibility(visible: boolean) {
    this.bandaInfo.visible = visible;
  }

  guardarCambios() {
    this.loaders.form = true;
    
    const request = this.isNewRecord ? 
      this.bandaInformacionService.createBandaInfo(this.bandaInfo) :
      this.bandaInformacionService.updateBandaInfo(this.bandaInfo.id, this.bandaInfo);

    request.pipe(
      finalize(() => {
        this.loaders.form = false;
      })
    )
    .subscribe(
      (response) => {
        this.toasts.success('Información de banda actualizada');
        // Call revalidate after successful save
        this.bandaInformacionService.revalidatePath()
          .subscribe(
            () => this.loadBandaInfo(),
            error => console.error('Error revalidating:', error)
          );
      },
      (error) => {
        this.toasts.error('Error al guardar los cambios');
      }
    );
  }

  getRemainingChars(): number {
    return this.MAX_CHARS - (this.bandaInfo.description ? this.bandaInfo.description.length : 0);
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/banda-informacion/banda-informacion.component.ts